import React, { Component } from 'react';

import './Page.css';

class Page extends Component {
  render() {
    return (
      <div className="Page-container">
        {this.renderHeader()}
        <div className="Page-body">
          {this.props.children}
        </div>
      </div>
    );
  }

  renderHeader =() => {
    const {
      header,
      title,
      renderControlsInline = false,
      renderControlsOnTop = false,
      controls,
    } = this.props;

    if (header) {
      return (<div className="Page-header">{header}</div>);
    } else if (renderControlsOnTop) {
      return (
        <div
          className="Page-header"
          style={{ "flexDirection": renderControlsInline ? "row" : "column"}}>
          {this.renderControls(controls, renderControlsInline)}
          <div className="Page-title">
            {title}
          </div>
        </div>
      )
    } else {
      return (
        <div
          className="Page-header"
          style={{ "flexDirection": renderControlsInline ? "row" : "column"}}>
          <div className="Page-title">
            {title}
          </div>
          {this.renderControls(controls, renderControlsInline)}
        </div>
      );
    }
  }

  renderControls = (controls, bInline) => {
    const className = bInline ? "Page-controls-inline" : "Page-controls";

    if (!controls) {
      return null;
    }

    return (
      <div className={className}>
        {controls}
      </div>
    )
  }
}

export default Page;


// WEBPACK FOOTER //
// ./src/pages/Page/Page.js